<div class="db-builder-signout">
  <div class="db-builder-signout-header">
    <img src="assets/images/logos/10web_name_logo_dark.svg" alt=""/>
  </div>
  <div class="db-builder-signout-body">
    <div class="db-builder-signout-body-title">Getting started with AI Website Builder with these 3 steps.</div>
    <div class="db-builder-signout-body-desc">As it is a new product with different subscription plans, you need to create a separate account.</div>
    <div class="db-builder-signout-body-wrap">
      <div class="db-builder-signout-body-wrap-steps-wrap">
        <div class="db-builder-signout-body-wrap-steps">
          <div class="db-builder-signout-body-wrap-step">
            <div class="db-builder-signout-content-item-desc-check"><i class="db-icon db-icon-checkbox-round"></i></div>
            <div class="db-builder-signout-content-item-desc-check-text">Log out from your current account</div>
          </div>
          <div class="db-builder-signout-body-wrap-step">
            <div class="db-builder-signout-content-item-desc-check">
              <img class="db-builder-signout-content-item-desc-check-image" src="assets/images/icons/rounded_check_yellow.svg" alt=""/>
            </div>
            <div class="db-builder-signout-content-item-desc-check-text">Sign up for AI Website Builder’s demo account<br/>with a new email address</div>
          </div>
          <div class="db-builder-signout-body-wrap-step">
            <div class="db-builder-signout-content-item-desc-check"><i class="db-icon db-icon-checkbox-round"></i></div>
            <div class="db-builder-signout-content-item-desc-check-text">Test out the magic by yourself and let us<br/>know what you think</div>
          </div>
        </div>
        <div class="db-builder-signout-body-wrap-steps-button">
          <a class="db-button db-button_info" (click)="signOut()"><span>Log Out</span></a>
        </div>
      </div>
      <div class="db-builder-signout-body-wrap-image">
        <img src="../../../assets/images/switch-account.png"/>
        <div class="db-builder-signout-body-wrap-image-text">We are currently developing a switching option which<br/>will allow you to sign in to your multiple accounts at once.</div>
      </div>
    </div>
  </div>
</div>
